module.exports = __webpack_public_path__ + "img/m1.3057f5e2.png";